/* eslint-disable max-len */
import React from 'react';
import SummaryDetailsCover from '../SummaryDetailsCover';
import { formatCash } from '../../utils/tableHelpers';
import './PropertyComp.scss';
import EmptyImageIcon from '../../svgs/EmptyImageIcon';
import PlainFile from '../ViewImageComponent/PlainFile';

interface IPropertyComp{
  property:any;
  status?:string;
  width?:string;
}
const PropertyComp = ({ property, width }:IPropertyComp) => (
  <SummaryDetailsCover width="100%" maxWidth={width}>
    <div className="property-comp-cover">
      <div className="items-comp-title">
        Property details
      </div>
      <div className="row property-comp-body">
        {property
          ? (
            <div className="property-comp-details-cover">
              <aside>
                <div className="mb-1 align-items-start">
                  <div className="property-comp-details-title">
                    {property?.propertyAddress}
                  </div>

                  <div className="property-comp-details-value">
                    {formatCash(property?.rentAmount || 0, '$ ')}
                  </div>
                </div>
              </aside>
              <div className="doc-wrap">
                { property?.leaseAgreementDoc ? (
                  <PlainFile
                    name="Lease Agreement"
                    docType={property?.meta?.leaseFileDetails?.docKey}
                    fileSize={property?.meta?.leaseFileDetails?.fileSize}
                    imageType={property?.meta?.leaseFileDetails?.fileType}
                    fileExt={property?.meta?.leaseFileDetails?.extention}
                    documentUrl={property?.leaseAgreementDoc}
                  />
                ) : <EmptyImageIcon />}
              </div>

            </div>
          )
          : <span className="no-items"> No Property available</span>}
      </div>
    </div>

  </SummaryDetailsCover>

);

export default PropertyComp;
